import React from "react";
import "../styles/contact.css";
import mailLogo from "../assets/email.jpg";
import LinkedinLogo from "../assets/linkedinlogo.jpg";
import InstagramLogo from "../assets/instalogo.jpg";
import FacebookLogo from "../assets/facebooklogo.jpg";
import LocationLogo from "../assets/location.jpg";
import PhoneLogo from "../assets/phone.jpg";

// Reusable link component
const IconLink = ({ src, alt, href, children }) => {
  const iconSize = "24px"; // smaller icon for compact cards
  return (
    <p className="contact-details">
      <img
        src={src}
        alt={alt}
        style={{ width: iconSize, height: iconSize, verticalAlign: "middle" }}
      />{" "}
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label={alt}>
        {children}
      </a>
    </p>
  );
};

// Reusable text component (no link)
const IconText = ({ src, alt, text }) => {
  const iconSize = "24px"; // smaller icon
  return (
    <p className="contact-details">
      <img
        src={src}
        alt={alt}
        style={{ width: iconSize, height: iconSize, verticalAlign: "middle" }}
      />{" "}
      {text}
    </p>
  );
};

const Contact = () => {
  return (
    <div className="contact-container">
      <h1 className="contact-title">Get in Touch</h1>
      <p className="contact-subtitle">
        We’d love to hear from you! Whether you're a client, a customer, or just curious — drop us a line.
      </p>

      <div className="contact-content">
        <div className="contact-details">
          <h2>📩 Contact Us</h2>
          <p>For any queries regarding our services or programs, reach out:</p>

          <IconLink src={mailLogo} alt="Gmail" href="mailto:reachus@neelaverse.com">
            reachus@neelaverse.com
          </IconLink>

          <IconLink src={PhoneLogo} alt="Phone" href="tel:+918121956868">
            +91-8121956868
          </IconLink>

          <IconLink src={LinkedinLogo} alt="LinkedIn" href="https://www.linkedin.com/company/neelaverse">
            neelaverse
          </IconLink>

          <IconLink src={InstagramLogo} alt="Instagram" href="https://www.instagram.com/neelaverse_technologies">
            neelaverse_technologies
          </IconLink>

          <IconLink src={FacebookLogo} alt="Facebook" href="https://facebook.com/NEELAverseTechnologies">
            NEELAverseTechnologies
          </IconLink>

          <IconText
            src={LocationLogo}
            alt="Location"
            text="NEELAverse Technologies Pvt Ltd, 4th Floor, Pinakin Spaces Building, near Raidurg Metro, Hitech City, Hyderabad, Telangana - 500081, India."
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
